import { Component, OnInit, Input, ChangeDetectorRef } from "@angular/core";
import { FinanceCampaignRowComponent } from "./finance-campaign-row/finance-campaign-row.component";
import { CampaignFinance } from "../../../@core/data/campaignFinance";
import { CampaignFinanceService } from "../../../@core/api/campaignFinance.service";
import { NbWindowService, NbWindowState } from "@nebular/theme";
import { LenguageService } from "../../../@core/utils/lenguage.service";
import { Router } from "@angular/router";

@Component({
  selector: "ngx-finance-campaigns-table",
  templateUrl: "./finance-campaigns-table.component.html",
  styleUrls: ["./finance-campaigns-table.component.scss"],
})
export class FinanceCampaignsTableComponent implements OnInit {
  filters: any;
  @Input() type: string;
  @Input() assigned: boolean = false;
  campaigns: CampaignFinance[];
  lastPage: boolean;
  loading: boolean;
  pageNumberShow: number = 1;
  pagination = {
    perPage: 100,
    pageNumber: 0,
  };
  order = {
    field: "timestamp",
    direction: "desc",
  };
  range: any;
  selectedRowId: string = "";
  addFilter: boolean = false;
  dateRange: {
    dateStart: number;
    dateEnd: number;
  };

  constructor(
    private windowService: NbWindowService,
    private router: Router,
    private campaignService: CampaignFinanceService,
    public language: LenguageService
  ) {}

  async ngOnInit() {
    this.getCampaignsFinance();
  }

  nextPage() {
    if (!this.lastPage && !this.loading) {
      this.pagination.pageNumber++;
      this.getCampaignsFinance();
      this.pageNumberShow++;
    }
  }

  prevPage() {
    if (this.pagination.pageNumber > 0 && !this.loading) {
      this.pagination.pageNumber--;
      this.getCampaignsFinance();
      this.pageNumberShow--;
    }
  }

  selectRow(data) {
    console.log(data);
    if (data.select) {
      this.selectedRowId = data.id;
    } else {
      this.selectedRowId = "";
    }
    /* 
        let leads = this.leads;
        this.leads = [];
        this.leads = leads; */
  }

  async getCampaignsFinance() {
    this.loading = true;
    this.campaigns = <CampaignFinance[]>(
      await this.campaignService.getCampaignsFinance(
        this.pagination,
        this.filters,
        this.order
      )
    );
    this.loading = false;

    if (this.campaigns.length < this.pagination.perPage) {
      this.lastPage = true;
    } else {
      this.lastPage = false;
    }
  }

  async createCampaignFinance() {
    this.loading = true;
    this.loading = false;
    this.router.navigate(["home", "finance-campaign"]);
  }

  rangeChanged() {
    let dateEnd = new Date(this.range.end).getTime() + 24 * 60 * 60 * 1000;
    let dateStart = (new Date(this.range.start).getTime() * 1000) / 1000;
    this.filters.dateRange = { dateStart, dateEnd };
  }

  async removeFilters() {
    this.dateRange = undefined;
    this.filters = undefined;
    this.addFilter = false;
    await this.getCampaignsFinance();
  }
}
